<template>
  <projectWrapper />
  <div
    id="project"
    class="pt-62.5 w-full flex flex-col slide min-h-screen"
  >
    <div class="header px-23.5 flex flex-col gap-18.5">
      <div
        class="left flex flex-col flex-shrink-0 justify-between items-start"
      >
        <h2 class="font-light fz-45" style="color: #ff2e53">
          {{ text.name }}
        </h2>
<!--        <a-->
<!--          href="#project"-->
<!--          class="w-max to-top transform transition cursor-pointer"-->
<!--        >-->
<!--          <svg-->
<!--            width="14"-->
<!--            height="13"-->
<!--            viewBox="0 0 14 13"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <path d="M1 6L7 12L13 6" stroke-linejoin="round" />-->
<!--            <path d="M6.99998 0V12" stroke-linejoin="round" />-->
<!--          </svg>-->
<!--          <p-->
<!--            class="fz-10 font-medium uppercase mt-2.5"-->
<!--            style="letter-spacing: 0.3em"-->
<!--          >-->
<!--            scroll-->
<!--          </p>-->
<!--        </a>-->
      </div>
      <div class="right flex flex-col">
        <div class="top flex gap-5">
          <div class="top-left flex flex-col w-120">
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-10">
              <p
                class="uppercase font-medium fz-12 mb-5"
                style="color: #6e758d"
              >
                {{ text.taskTitle }}
              </p>
              <p class="fz-16 font-medium w-87.5">{{ text.title }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
          </div>
          <div class="top-right flex flex-col w-55">
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content mt-5 mb-10">
              <p
                class="uppercase font-medium fz-12 mb-5 w-38"
                style="color: #6e758d"
              >
                {{ text.realizationTimeTitle }}
              </p>
              <p class="fz-50">{{ text.realizationTime }}</p>
            </div>
            <div
              class="line w-full mt-auto h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
          </div>
        </div>
        <p class="mt-22 fz-201 font-medium">{{ text.text[0] }}</p>
      </div>
    </div>
    <img
      :src="require('@/assets/images/projects/' + projectId + '/first.png')"
      alt=""
      class="first-image w-full mt-[14.5rem]"
    />

    <p class="prolog px-23.5 mt-37.5 font-medium fz-201">
      {{ text.text[1] }}
    </p>

    <div class="problems px-23.5 flex flex-col gap-12.5 mt-25">
      <div
        class="left flex flex-col w-130.7 flex-shrink-0 justify-between items-start"
      >
        <h2 class="font-light fz-301" style="color: #ff2e53">
          {{ text.problemsTitle }}
        </h2>
      </div>
      <div class="right flex flex-col">
        <div class="top flex gap-4.5">
          <div class="top-left flex flex-col w-70">
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12 mb-5"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                01
              </h6>
              <p class="fz-16 font-medium">{{ text.problems[0] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12 mb-5"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                03
              </h6>
              <p class="fz-16 font-medium">{{ text.problems[2] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
          </div>
          <div class="top-right flex flex-col w-70">
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12 mb-5"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                02
              </h6>
              <p class="fz-16 font-medium h-12">{{ text.problems[1] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12 mb-5"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                04
              </h6>
              <p class="fz-16 font-medium pr-3">{{ text.problems[3] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="px-23.5 mt-37.5">
      <slider
          :slides-container-classes="'mb-12.5 gap-5 '"
          :slider-classes="'w-full relative tablet-products-slider'"
          :similar-slides="true"
          :pagination="true"
          pagination-container-classes="gap-5"
      >
        <template v-slot:slides>
          <div
              class="slider-slide w-145 h-100 flex flex-col"
              v-for="item in text.images"
              :key="item"
          >
            <img
                :src="require('@/assets/images/projects/' + projectId + '/slider/' + item)"
                class="h-full w-145"
                style="background: rgba(110, 117, 141, 0.2)"
                alt=""
            />
            <p class="fz-16 " style="line-height: 1.5625rem">
              {{ item.text }}
            </p>
          </div>
        </template>
        <template v-slot:pagination>
          <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
        </template>
      </slider>
    </div>

    <p class="prolog-2 px-23.5 mt-37.5 font-medium fz-201">
      {{ text.text[2] }}
    </p>

    <div class="result px-23.5 flex flex-col gap-12.5 mt-37.5">
      <div
        class="left flex flex-col flex-shrink-0 justify-between items-start"
      >
        <h2 class="font-light fz-301" style="color: #ff2e53">
          {{ text.resultTitle }}
        </h2>
      </div>
      <div class="right flex flex-col">
        <div class="top flex gap-5">
          <div class="top-left flex flex-col w-70">
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                01
              </h6>
              <p class="fz-16 font-medium w-62.5 h-18.75">{{ text.result[0] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                03
              </h6>
              <p class="fz-16 font-medium w-62.5 h-25">{{ text.result[2] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                05
              </h6>
              <p class="fz-16 font-medium w-62.5 h-25">{{ text.result[4] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
          </div>
          <div class="top-right flex flex-col w-70">
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                02
              </h6>
              <p class="fz-16 font-medium w-70 h-18.75">{{ text.result[1] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                04
              </h6>
              <p class="fz-16 font-medium w-62.5 h-25">{{ text.result[3] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
            <div class="content my-7.5">
              <h6
                class="mb-7.5 uppercase font-medium fz-12"
                style="color: #6e758d; letter-spacing: 0.3rem"
              >
                06
              </h6>
              <p class="fz-16 font-medium w-62.5 h-25">{{ text.result[5] }}</p>
            </div>
            <div
              class="line w-full h-px"
              style="background: rgba(151, 163, 203, 0.3)"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <a href="#project"
      class="w-max to-top ml-23.5 mt-25 transform transition cursor-pointer"
    >
      <svg
        width="14"
        class="transform transition duration-800 rotate-180"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 6L7 12L13 6" stroke-linejoin="round" />
        <path d="M6.99998 0V12" stroke-linejoin="round" />
      </svg>
      <p
        class="fz-10 font-medium uppercase mt-2.5"
        style="letter-spacing: 0.3em"
      >
        back to top
      </p>
    </a>
<!--    <div-->
<!--      class="next w-full h-[13.375rem] mt-25 cursor-pointer relative"-->
<!--      v-if="text.nextTitle && text.nextImage"-->
<!--    >-->
<!--      &lt;!&ndash; Background start &ndash;&gt;-->
<!--      <div class="absolute w-full h-full shadow z-10"></div>-->
<!--      <img-->
<!--        class="w-full h-full"-->
<!--        :src="require('@/assets/images/projects/' + projectId + '/next.png')"-->
<!--        alt=""-->
<!--      />-->
<!--      <div class="line absolute bottom-0 h-2"></div>-->
<!--      &lt;!&ndash; Background end &ndash;&gt;-->
<!--      <div class="content absolute z-20 bottom-25 left-23.5">-->
<!--        <p class="next-post-title fz-13 uppercase font-semibold mb-2.5">-->
<!--          {{ text.next }}-->
<!--        </p>-->
<!--        <h3 class="w-110 fz-301" style="color: #f22959;">{{ text.nextTitle }}</h3>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import projectWrapper from "./projectWrapper";
import slider from "@/components/tablet/reuseable/slider";
import {mapState} from "vuex";

export default {
  name: "project",
  components: {
    projectWrapper,
    slider,
  },
  computed: {
    text() {
      return require("@/assets/text/project/" + this.lang + ".json").projects[this.projectId];
    },
    ...mapState(['lang', 'projectId']),
  }
};
</script>

<style scoped lang="scss">
// Next post start
.next {
  overflow: hidden;
  transition: all linear 0.3s;
  .line {
    transition: all linear 0.3s;
    background: #ff2e53;
    width: 0;
    z-index: 11;
  }
  img.w-full {
    transition: all linear 0.3s;
  }
  .shadow {
    transition: all linear 0.3s;
    background: rgba(0, 0, 0, 0.6);
  }
}
.next {
  //margin-top: 7.125rem;
  //height: 20.625rem;
  .line {
    width: 100%;
  }
  img.w-full {
    transform: scale(1.15);
  }
  .shadow {
    background: rgba(0, 0, 0, 0.7);
  }
}
// Next post end

//Back to top button start
.to-top {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: rgba(151, 163, 203, 0.6);
    }
  }
  p {
    transition: all linear 0.3s;
    color: rgba(151, 163, 203, 0.6);
  }
}
.to-top:hover {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: white;
    }
  }
  p {
    transition: all linear 0.3s;
    color: white;
  }
}
//Back to top button end
</style>
